<template>
  <PageHeader :showBreadcrumb="true" />
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Phase 1 - Create Quality Assurance Exam</h2>
        <Button size="lg" class="me-2" rounded raised label="Create an Exam" severity="primary" @click="router.push('/qualityAssurance/CreateExam')" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Phase 1 - Quality Assurance File Uploads</h2>
        <Button size="lg" class="me-2" rounded raised label="Quality Assurance File Uploads" severity="primary" @click="router.push('/qualityAssurance/QualityAssuranceFileUploads')" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Phase 2 - Exam Summary and Findings</h2>
        <Button size="lg" class="me-2" rounded raised label="Exam Summary and Findings" severity="primary" @click="router.push('/qualityAssurance/ExamSummaryFindings')" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Phase 3 - Reporting Phase</h2>
        <Button size="lg" class="me-2" rounded raised label="Reporting Phase" severity="primary" @click="router.push('/qualityAssurance/ReportingPhase')" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12" v-if="userStore.isStaffUser">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Phase 4 - Exam Management for Quality Assurance</h2>
        <Button size="lg" class="me-2" rounded raised label="Exam Management for Quality Assurance" severity="primary" />
      </div>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="col-lg-6 col-md-12">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">File Uploads by HMO/CBP</h2>
        <Button size="lg" class="me-2" rounded raised label="File Uploads by HMO/CBP" severity="primary" @click="router.push('/qualityAssurance/QualityAssuranceFileUploadsByHmoCbp')" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import PageHeader from "@/components/common/PageHeader.vue";
import Button from 'primevue/button';

const router = useRouter();
const userStore = useAuthStore();
</script>
<style scoped>
.portal-box {
  height: 200px;
}
.tx-col {
  height: 75%;
}
</style>

